import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { integrationsService } from '@/services/integrations';
import type { GetIntegrationsParams } from '@/services/integrations';

export function useIntegrations(params: GetIntegrationsParams = {}) {
  return useQuery({
    queryKey: ['integrations', params],
    queryFn: async () => {
      const response = await integrationsService.listIntegrations(params);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar integrações');
      }
      return response.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 2,
  });
}
